import { BindingCreator } from '@dreryk/react-common';
import { ButtonGroup } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../../translations';
import { DateFilterType } from '../../../AppointmentsFilterChips/DateChipFilter.types';
import { FilterFormBean } from '../../AppointmentsFilterPanel';

type ButtonGroupFieldProps = {
   readonly register: BindingCreator<FilterFormBean>;
};

const DAY_ITEM = {
   name: DateFilterType.DAY,
   label: appointmentsTranslationKeys.filters.day,
   testId: 'day',
};
const RANGE_ITEM = {
   name: DateFilterType.RANGE,
   label: appointmentsTranslationKeys.filters.range,
   testId: 'range',
};
const items = [DAY_ITEM, RANGE_ITEM];

const ButtonGroupField = (props: ButtonGroupFieldProps): JSX.Element => {
   const buttonController = props.register(ButtonGroupField.fieldName, { required: false });
   return <ButtonGroup controller={buttonController} items={items} testId={'appointmentsFilter'} />;
};

ButtonGroupField.fieldName = 'date.type' as const;
ButtonGroupField.displayName = 'ButtonGroupField';
export { ButtonGroupField };
